import { Tooltip } from '@starryui10/Components/Tooltip';
import { FiltersAdvancedV2 } from '@starryui10/images/icons/FiltersAdvancedV2';
import { FiltersV2 } from '@starryui10/images/icons/FiltersV2';
import { List } from '@starryui10/images/icons/List';
import React from 'react';
import styled from 'styled-components';
import { GetCaptionFromViewType } from '../../../utils/stringUtil';

export const ViewTypeIcon = ({ viewType }: { viewType: starrez.DirectoryViewType | undefined }) => {
    const getIcon = () => {
        switch (viewType) {
            case 'ACTIVE_ENTRIES':
            case 'ALL_ENTRIES':
                return <FiltersAdvancedV2 />;
            case 'SAVED_LIST':
                return <List />;
            case 'DYNAMIC_LIST':
                return <FiltersV2 />;
            default:
                return null;
        }
    };

    if (!viewType) {
        return <></>;
    }

    return (
        <IconWrapper>
            <Tooltip caption={GetCaptionFromViewType(viewType)} maxWidth={'25ch'}>
                {(visibleFunc) => (
                    <IconWrapper onMouseEnter={() => visibleFunc(true)} onMouseLeave={() => visibleFunc(false)}>
                        {getIcon()}
                    </IconWrapper>
                )}
            </Tooltip>
        </IconWrapper>
    );
};

const IconWrapper = styled.span`
    display: inline-block;
`;
